var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointBrand01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 20,
    viewBox: "0 0 88 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rouwt3ysqa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 462",
    style: {
      fill: "none"
    },
    d: "M0 0h86.736v18.147H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1zmzoir9yb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 452",
    style: {
      fill: "none"
    },
    d: "M0 0h1.146v1.252H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "besgdw1i2c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 453",
    style: {
      fill: "none"
    },
    d: "M0 0h1.221v1.348H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g522s8gd3d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 454",
    style: {
      fill: "none"
    },
    d: "M0 0h1.059v1.088H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p16qekfkse"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 455",
    style: {
      fill: "none"
    },
    d: "M0 0h1.073v1.073H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uc8rdpwugf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 456",
    style: {
      fill: "none"
    },
    d: "M0 0h.759v.965H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nkip21egqg"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 457",
    style: {
      fill: "none"
    },
    d: "M0 0h.999v.999H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "oqp0j16x9h"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 458",
    style: {
      fill: "none"
    },
    d: "M0 0h.868v.868H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kbbdwke0oi"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 459",
    style: {
      fill: "none"
    },
    d: "M0 0h.899v1.004H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9084",
    style: {
      fill: "none"
    },
    d: "M0 0h88v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9503"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 767",
    style: {
      clipPath: "url(#rouwt3ysqa)"
    },
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 766"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 765",
    style: {
      clipPath: "url(#rouwt3ysqa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 99",
    d: "m396 134.752-.054-.037q-.29-.176-.558-.318a2.783 2.783 0 0 0-.71-.247 1.531 1.531 0 0 0-.426-.115c-.1-.012-.2-.025-.3-.042a3.872 3.872 0 0 0-.365-.03 2.71 2.71 0 0 1-.291-.022 5.558 5.558 0 0 0-.465-.017h-.411c-.135 0-.276 0-.426.01a3.9 3.9 0 0 1-.4 0 7.608 7.608 0 0 0-1.176.073 56.46 56.46 0 0 0-1.19.164 2.093 2.093 0 0 0-.737.172 1.343 1.343 0 0 0-.417.3 1.012 1.012 0 0 0-.2.27 1.559 1.559 0 0 0-.1.261 1.5 1.5 0 0 0-.057.316.348.348 0 0 1-.011.067l-.039.331a1.93 1.93 0 0 0 0 .325l.832 9.509a2.256 2.256 0 0 0 .143.653 3.658 3.658 0 0 0 .186.4 1.247 1.247 0 0 0 .563.566 1.7 1.7 0 0 0 .62.147 2.668 2.668 0 0 0 .413-.006c.069-.006.14-.014.213-.025a1.7 1.7 0 0 0 .7-.26 1.389 1.389 0 0 0 .6-.967q.05-.37.074-.719l-.263-3.093c.177-.025.336-.046.478-.063.174-.022.387-.055.633-.1a16.706 16.706 0 0 0 1.512-.33 6.913 6.913 0 0 0 1.427-.572 3.239 3.239 0 0 0 1.471-1.369 3.735 3.735 0 0 0 .439-1.773 4.443 4.443 0 0 0-.441-1.885 4.27 4.27 0 0 0-1.267-1.574m-1.868 3.8a1.572 1.572 0 0 1-.532.375 3.651 3.651 0 0 1-.8.249 8.368 8.368 0 0 1-.854.124l-.474.049v-.012c-.017-.2-.029-.392-.037-.621l-.092-1.057q-.018-.208-.04-.423l.142-.007.775-.033c.111 0 .2-.01.274-.015a4.729 4.729 0 0 1 .713.088 2.33 2.33 0 0 1 .613.208.927.927 0 0 1 .343.29.719.719 0 0 1 .119.379.589.589 0 0 1-.149.405",
    transform: "translate(-376.718 -130.146)",
    style: {
      fillRule: "evenodd",
      fill: "#28ac4c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 740",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 739"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 738",
    style: {
      clipPath: "url(#1zmzoir9yb)"
    },
    transform: "translate(11.876 4.753)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 100",
    d: "M421.17 169.715c.178.149.534.018.8-.294s.329-.686.151-.835-.534-.018-.8.294-.329.686-.151.835",
    transform: "translate(-421.07 -168.524)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 101",
    d: "M2363.3 146.48a9.6 9.6 0 0 0 .01-1.249v-.009a7.15 7.15 0 0 0-.468-2.021 6.579 6.579 0 0 0-1.1-1.866 5.945 5.945 0 0 0-1.7-1.387 5.031 5.031 0 0 0-2.3-.6l-2.876-.069-.155.007-.073.033a1.015 1.015 0 0 0-.468.053l-.2.08a1.282 1.282 0 0 0-.322.193 1.066 1.066 0 0 0-.384.531 2.031 2.031 0 0 0-.14.505 1.237 1.237 0 0 0-.047.336V151.1a1.964 1.964 0 0 0 .012.21c.007.067.018.138.033.213l.019.073c.02.059.037.115.051.165a1.276 1.276 0 0 0 .115.286 1.834 1.834 0 0 0 .11.213.964.964 0 0 0 .291.31 1.435 1.435 0 0 0 .683.289 4.507 4.507 0 0 0 .9.11h.171c.231 0 .459-.01.668-.028a15.224 15.224 0 0 0 2.455-.314 5.97 5.97 0 0 0 2.342-1.041 4.976 4.976 0 0 0 1.538-1.8 7.6 7.6 0 0 0 .692-2.089c.06-.393.105-.8.134-1.22m-3.86.743a3.231 3.231 0 0 1-.4 1.006 2.406 2.406 0 0 1-.569.631 2.559 2.559 0 0 1-.687.359 3.458 3.458 0 0 1-.812.17q-.193.017-.392.03v-4.049c0-.386.006-.783.018-1.208V142.811c.123.008.247.018.372.03a5.242 5.242 0 0 1 .891.163 2.569 2.569 0 0 1 .688.3 1.413 1.413 0 0 1 .434.429 3.915 3.915 0 0 1 .418 1.029 5.487 5.487 0 0 1 .171 1.232 4.943 4.943 0 0 1-.123 1.227",
    transform: "translate(-2286.715 -135.352)",
    style: {
      fill: "#f84c4e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 102",
    d: "M1168.961 177.786a8.336 8.336 0 0 0-.321-1.506 6.985 6.985 0 0 0-.815-1.8 4.724 4.724 0 0 0-1.362-1.392 4.39 4.39 0 0 0-1.906-.687 5.91 5.91 0 0 0-2.369.253 4.188 4.188 0 0 0-1.544.85 6.252 6.252 0 0 0-1.116 1.272 6.737 6.737 0 0 0-.741 1.488 8.125 8.125 0 0 0-.374 1.457 10.8 10.8 0 0 0-.108 1.535 9.18 9.18 0 0 0 .147 1.633 7.563 7.563 0 0 0 .472 1.6 5.066 5.066 0 0 0 .9 1.42 4.748 4.748 0 0 0 1.038.894 5.483 5.483 0 0 0 1.2.571 5.593 5.593 0 0 0 1.284.264l.076.006a5.26 5.26 0 0 0 2.964-.686 4.3 4.3 0 0 0 1.39-1.309 6.532 6.532 0 0 0 .411-.7 5.681 5.681 0 0 0 .32-.77 8.078 8.078 0 0 0 .368-1.359 10.162 10.162 0 0 0 .092-3.034m-3.629 2.923-.006.022a2.7 2.7 0 0 1-.32.717 1.538 1.538 0 0 1-1.126.87 1.555 1.555 0 0 1-.864-.107 1.773 1.773 0 0 1-.748-.6 2.163 2.163 0 0 1-.325-.647 4.7 4.7 0 0 1-.18-.848 5.777 5.777 0 0 1-.04-.9 8.149 8.149 0 0 1 .08-.9 4.89 4.89 0 0 1 .439-1.514 2.186 2.186 0 0 1 .384-.565 1.361 1.361 0 0 1 .477-.331 2.147 2.147 0 0 1 .922-.189 1.2 1.2 0 0 1 .606.19 1.472 1.472 0 0 1 .45.5 3.606 3.606 0 0 1 .347.861 6.353 6.353 0 0 1 .177 1.777 5.95 5.95 0 0 1-.272 1.656",
    transform: "translate(-1125.633 -167.507)",
    style: {
      fill: "#4d9de0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 103",
    d: "M10.253 144a3.386 3.386 0 0 0-1.029-1.372 4.505 4.505 0 0 0-1.539-.783 5.477 5.477 0 0 0-1.707-.239c-.5.01-1.007 0-1.508-.021a3.473 3.473 0 0 1-.448-.051 1.44 1.44 0 0 1-.348-.107.591.591 0 0 1-.2-.142.279.279 0 0 1-.058-.159.814.814 0 0 1 .015-.4.838.838 0 0 1 .184-.321 1.144 1.144 0 0 1 .351-.249 2.672 2.672 0 0 1 .553-.19 3.925 3.925 0 0 1 1.117-.051 2.089 2.089 0 0 1 .911.27c.119.08.25.171.394.273a3.641 3.641 0 0 0 .538.314 1.728 1.728 0 0 0 .717.17 1.368 1.368 0 0 0 .866-.312 1.294 1.294 0 0 0 .548-.964 1.834 1.834 0 0 0-.187-.9 2.908 2.908 0 0 0-.493-.721 3.139 3.139 0 0 0-.574-.5 3.706 3.706 0 0 0-.9-.459 5.84 5.84 0 0 0-1.031-.257 7.665 7.665 0 0 0-1.1-.092 8.632 8.632 0 0 0-1.112.06 7.706 7.706 0 0 0-1.789.431 3.8 3.8 0 0 0-1.473 1 3.882 3.882 0 0 0-.826 1.639 4.321 4.321 0 0 0-.049 1.81 4.021 4.021 0 0 0 .717 1.65 3.034 3.034 0 0 0 1.561 1.1 4.667 4.667 0 0 0 .938.216c.29.035.591.059.9.07s.585.014.872.013a6.111 6.111 0 0 1 .749.042 4.132 4.132 0 0 1 .592.131 1.3 1.3 0 0 1 .373.176.679.679 0 0 1 .2.227 1.107 1.107 0 0 1 .107.437.862.862 0 0 1-.126.553 1.439 1.439 0 0 1-.506.486 2.229 2.229 0 0 1-.81.277 2.366 2.366 0 0 1-.894-.038 2.86 2.86 0 0 1-.617-.343 1.673 1.673 0 0 1-.428-.432 1.483 1.483 0 0 0-.5-.538 1.738 1.738 0 0 0-.585-.235 2.263 2.263 0 0 0-1.1.065 1.365 1.365 0 0 0-.685.5 1.726 1.726 0 0 0-.282.658 1.866 1.866 0 0 0 0 .717 1.726 1.726 0 0 0 .241.624 5.243 5.243 0 0 0 .847 1.063 4.209 4.209 0 0 0 1.169.79 5.4 5.4 0 0 0 2.274.446q.275 0 .545-.026a6.758 6.758 0 0 0 1.8-.407 5.89 5.89 0 0 0 1.976-1.226 3.686 3.686 0 0 0 1.119-2.019 4.183 4.183 0 0 0 .076-.627 5.036 5.036 0 0 0-.122-1.393 3.457 3.457 0 0 0-.208-.633",
    transform: "translate(.001 -132.876)",
    style: {
      fill: "#f84c4e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 743",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 742"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 741",
    style: {
      clipPath: "url(#besgdw1i2c)"
    },
    transform: "translate(.906 5.471)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 104",
    d: "M32.214 195.282c.178.149.554-.006.84-.347s.374-.738.2-.888-.554.006-.841.347-.374.738-.2.888",
    transform: "translate(-32.122 -193.99)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 105",
    d: "M2195.221 128.694a2.934 2.934 0 0 0-.125-.498l-.024-.063a1.313 1.313 0 0 0-.308-.462 1.266 1.266 0 0 0-.715-.385 3.3 3.3 0 0 0-.269-.033 2.059 2.059 0 0 0-1.089.2l-.078.048a1.764 1.764 0 0 0-.552.663 2.563 2.563 0 0 0-.247.96c0 .122 0 .241-.008.354s-.014.229-.027.4a23.32 23.32 0 0 0-.034 1.2v2.4c0 .4-.006.788-.018 1.179l-.035 4.295a2.016 2.016 0 0 0 .011.453c.008.04.014.081.018.122.006.061.014.122.024.182a1.7 1.7 0 0 0 .025.251 1.676 1.676 0 0 0 .1.337.873.873 0 0 0 .062.114.778.778 0 0 0 .089.167 1.4 1.4 0 0 0 .468.539l.083.047a1.86 1.86 0 0 0 .8.184 1.824 1.824 0 0 0 .417-.048 1.361 1.361 0 0 0 .742-.341 1.487 1.487 0 0 0 .219-.233 2.2 2.2 0 0 0 .154-.234l.051-.116c.027-.085.051-.165.07-.237a1.206 1.206 0 0 1 .041-.128l.033-.124q.021-.126.031-.221a1.871 1.871 0 0 0 .012-.2l.1-9.485v-.3c0-.053 0-.1.006-.152.007-.082.011-.174.011-.279 0-.088 0-.177-.01-.265 0-.055-.016-.151-.033-.287",
    transform: "translate(-2129.871 -123.657)",
    style: {
      fill: "#ffad30",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 106",
    d: "M2713.827 156.1a1.99 1.99 0 0 0-.5-.374l-.291-.115a1.256 1.256 0 0 0-.359-.07 1.082 1.082 0 0 1-.121-.012l-.072-.007q-.472-.02-.932 0l-2.014.07q-.41.014-.641.014h-.128q.719-1.131 1.444-2.246 1.022-1.573 2.053-3.164.224-.345.465-.691.253-.364.488-.746c.077-.12.172-.269.281-.448a3.556 3.556 0 0 0 .316-.649 2.174 2.174 0 0 0 .138-.744 1.145 1.145 0 0 0-.417-.881l-.137-.087a.47.47 0 0 1-.091-.053 1.593 1.593 0 0 0-.268-.161 2.051 2.051 0 0 0-1.121-.227 6.291 6.291 0 0 1-.76.011 3.522 3.522 0 0 0-.473.006 8.57 8.57 0 0 1-.371.021q-1.494.052-2.483.078c-.671.018-1.176.039-1.493.061l-.2.018a6.058 6.058 0 0 1-.625.062 2.573 2.573 0 0 0-.914.211 1.594 1.594 0 0 0-.663.544 1.363 1.363 0 0 0-.242.842 2.028 2.028 0 0 0 .087.55 1.229 1.229 0 0 0 .419.639 1.616 1.616 0 0 0 .824.365 5.439 5.439 0 0 0 .656.065q.675-.006 1.237-.017l1.076-.021q.522-.009 1.052-.028l-.384.623-.725 1.155c-.228.362-.461.711-.71 1.067l-1.515 2.377-.851 1.291-.043.076a.413.413 0 0 1-.028.054.537.537 0 0 1-.05.06l-.067.086c-.029.048-.063.107-.1.175s-.06.121-.1.217a.3.3 0 0 1-.031.058 1.541 1.541 0 0 0-.107.2 1.043 1.043 0 0 0-.119.222l-.12.327a1.165 1.165 0 0 0-.055.4.641.641 0 0 0 .012.112 1.026 1.026 0 0 0 .011.2 1.171 1.171 0 0 0 .056.212 1.028 1.028 0 0 0 .446.648 2.386 2.386 0 0 0 .395.24l.171.055c.068.011.125.018.177.024l.035.005a.742.742 0 0 0 .2.033l.061.01a1.874 1.874 0 0 0 .3.014l6.456-.225a2.1 2.1 0 0 0 .231-.021 2.83 2.83 0 0 0 .177-.033 1.569 1.569 0 0 0 .528-.175 1.311 1.311 0 0 0 .511-.342 1.6 1.6 0 0 0 .2-.265 1.038 1.038 0 0 0 .14-.4 1.509 1.509 0 0 0-.271-1.238z",
    transform: "translate(-2627.44 -141.401)",
    style: {
      fill: "#36a7a7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 746",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 745"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 744",
    style: {
      clipPath: "url(#g522s8gd3d)"
    },
    transform: "translate(77.023 5.058)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 107",
    d: "M2730.991 180.334c.17.159.5.08.739-.175s.293-.59.123-.749-.5-.08-.739.175-.293.59-.123.749",
    transform: "translate(-2730.893 -179.328)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 108",
    d: "M1823.915 143.094c-.074-.1-.154-.2-.24-.306s-.191-.22-.3-.325l-.022-.019q-.419-.489-.855-.97a45.72 45.72 0 0 0-.915-.979c-.1-.1-.225-.227-.371-.38l-.483-.5c-.174-.18-.357-.367-.557-.567l-.127-.127 2.813-2.88.225-.224.045-.051a.668.668 0 0 1 .075-.08 1.794 1.794 0 0 0 .2-.2c.065-.066.123-.132.178-.2s.09-.112.155-.19a2.279 2.279 0 0 0 .164-.237l.135-.236a1.425 1.425 0 0 0 .118-.58l-.006-.084a1.16 1.16 0 0 0-.3-.654 1.068 1.068 0 0 0-.254-.249.766.766 0 0 1-.094-.081l-.073-.063a1.761 1.761 0 0 0-.37-.2 1.684 1.684 0 0 0-.441-.109 1.448 1.448 0 0 0-.875.169 1.976 1.976 0 0 0-.8.531l-.259.228a6.627 6.627 0 0 0-.31.292l-.045.045q-.469.453-.929.914c-.307.307-.616.623-.947.968l-.061.069-.006-1.444c0-.1 0-.188-.01-.273s-.018-.166-.029-.237a1.668 1.668 0 0 0-.166-.562 1.407 1.407 0 0 0-.117-.241 1.313 1.313 0 0 0-.218-.26 1.418 1.418 0 0 0-.687-.314l-.224-.036a2.159 2.159 0 0 0-.318-.023l-.4.072a1.379 1.379 0 0 0-.451.184 1.4 1.4 0 0 0-.593.675 2.167 2.167 0 0 0-.2.872c-.013.134-.02.271-.02.411a1.52 1.52 0 0 1-.025.268l-.009.156q-.017.614-.017 1.1c0 .327.006.7.018 1.128.034.836.051 1.629.051 2.363l.017 4.328a.963.963 0 0 0 .025.233c.009.055.016.106.021.152s.014.12.024.187a1.236 1.236 0 0 0 .137.5v.15l.123.123.006.012a1.5 1.5 0 0 0 .516.555l.055.029a2.035 2.035 0 0 0 .613.179 1.425 1.425 0 0 0 .171.01 1.727 1.727 0 0 0 .49-.075 1.337 1.337 0 0 0 .745-.355c.053-.054.1-.108.156-.167a1.04 1.04 0 0 0 .2-.339 3.383 3.383 0 0 0 .15-.5l.033-.157a1.293 1.293 0 0 0 .029-.266l-.029-2.147 2.276 2.387.224.242a1.2 1.2 0 0 1 .092.1 2.454 2.454 0 0 0 .179.2 1.568 1.568 0 0 0 .225.221l.19.155a2.665 2.665 0 0 0 .23.164c.069.044.135.085.194.12a1.715 1.715 0 0 0 .254.128 1.076 1.076 0 0 0 .368.077 1.29 1.29 0 0 0 .721-.115 1.369 1.369 0 0 0 .292-.154q.094-.066.206-.158a1.314 1.314 0 0 0 .486-.671 1.137 1.137 0 0 0-.02-.946 2.211 2.211 0 0 0-.438-.77",
    transform: "translate(-1763.705 -128.684)",
    style: {
      fill: "#5e70d5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 109",
    d: "M775.527 143.712a2.709 2.709 0 0 1-.05-.164 2.654 2.654 0 0 0-.061-.2 1.037 1.037 0 0 0-.369-.566 1.193 1.193 0 0 0-.664-.335 2.4 2.4 0 0 0-.269-.035 4.272 4.272 0 0 0-.292-.01 1.656 1.656 0 0 0-.843.227 1.93 1.93 0 0 0-.335.263 1.065 1.065 0 0 0-.263.435 2.263 2.263 0 0 0-.147.4 2.809 2.809 0 0 0-.077.431 8.3 8.3 0 0 0-.036.751q-.035.786-.044 1.5-.006.441-.008.908-.67 0-1.294-.016c-.6-.011-1.2-.017-1.835-.016l-.11.007.027-3.171a2.038 2.038 0 0 0-.02-.282 2.009 2.009 0 0 0-.129-.522 1.163 1.163 0 0 0-.331-.506 1.176 1.176 0 0 0-.713-.37 3.12 3.12 0 0 0-.542-.042 1.8 1.8 0 0 0-.811.2l-.079.048a1.851 1.851 0 0 0-.3.262 1.276 1.276 0 0 0-.24.39 2.324 2.324 0 0 0-.159.423 2.716 2.716 0 0 0-.078.434 4.701 4.701 0 0 0-.019.423c0 .1 0 .2-.017.354-.023.447-.037.817-.043 1.145s0 .707.008 1.116v1.206c0 .385-.006.759-.017 1.132l-.035 2.538-.017 1.6a1.825 1.825 0 0 0 .011.437l.033.168a.352.352 0 0 1 .007.065l.043.3a1.585 1.585 0 0 0 .1.338l.018.036a1.026 1.026 0 0 0 .069.174l.03.052a1.622 1.622 0 0 0 .566.555 1.882 1.882 0 0 0 1.225.135 1.388 1.388 0 0 0 .72-.312 1.308 1.308 0 0 0 .426-.582c.02-.063.041-.122.063-.183a1.69 1.69 0 0 0 .069-.238 1.892 1.892 0 0 0 .069-.451l.029-3.666 3.264-.015-.03 2.955v.052l-.034.067v.287a.92.92 0 0 0 .053.3c0 .025.007.05.01.076a1.1 1.1 0 0 1 .006.115l.044.3a1.428 1.428 0 0 0 .077.271l.061.169a1.079 1.079 0 0 0 .093.156 1.333 1.333 0 0 0 .5.53l.054.029a1.839 1.839 0 0 0 .8.182 2 2 0 0 0 .424-.046 1.388 1.388 0 0 0 .72-.312 1.3 1.3 0 0 0 .424-.577l.065-.188a1.632 1.632 0 0 0 .068-.236 1.9 1.9 0 0 0 .07-.453l.1-9.131v-.915a2.217 2.217 0 0 0-.023-.306z",
    transform: "translate(-743.723 -138.385)",
    style: {
      fill: "#ff8000",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 749",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 748"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 747",
    style: {
      clipPath: "url(#p16qekfkse)"
    },
    transform: "translate(22.414 4.843)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 110",
    d: "M794.8 172.7c.165.164.5.1.744-.149s.313-.58.149-.744-.5-.1-.744.149-.313.58-.149.744",
    transform: "translate(-794.707 -171.713)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 752",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 751"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 750",
    style: {
      clipPath: "url(#uc8rdpwugf)"
    },
    transform: "translate(29.202 4.792)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 111",
    d: "M1035.484 170.845c.151.087.391-.046.536-.3s.141-.526-.01-.614-.391.046-.536.3-.141.526.01.614",
    transform: "translate(-1035.368 -169.906)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 755",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 754"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 753",
    style: {
      clipPath: "url(#nkip21egqg)"
    },
    transform: "translate(51.815 4.67)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 112",
    d: "M1837.18 166.521c.123.123.423.023.67-.223s.347-.546.223-.67-.423-.023-.67.223-.347.546-.223.67",
    transform: "translate(-1837.127 -165.575)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 758",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 757"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 756",
    style: {
      clipPath: "url(#oqp0j16x9h)"
    },
    transform: "translate(57.774 4.63)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 113",
    d: "M2048.472 164.966c.123.123.39.057.6-.149s.272-.472.149-.6-.39-.057-.6.149-.272.472-.149.6",
    transform: "translate(-2048.41 -164.16)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 761",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 760"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 759",
    style: {
      clipPath: "url(#kbbdwke0oi)"
    },
    transform: "translate(62.705 4.141)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 114",
    d: "M2223.424 147.776a.539.539 0 1 0-.1-.666.482.482 0 0 0 .1.666",
    transform: "translate(-2223.237 -146.818)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 764",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 763"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 762",
    style: {
      clipPath: "url(#p16qekfkse)"
    },
    transform: "translate(67.726 4.717)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 115",
    d: "M2401.341 168.232c.165.164.5.1.744-.149s.313-.58.149-.744-.5-.1-.745.149-.313.58-.149.744",
    transform: "translate(-2401.251 -167.248)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116",
    d: "M1189.2 3.791A3.791 3.791 0 1 1 1185.405 0a3.791 3.791 0 0 1 3.791 3.791",
    transform: "translate(-1148.287)",
    style: {
      fill: "#f5f1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 117",
    d: "M1401.792 87.912a3.791 3.791 0 1 1-3.792-3.791 3.791 3.791 0 0 1 3.791 3.791",
    transform: "translate(-1354.887 -81.748)",
    style: {
      fill: "#f5f1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 118",
    d: "M1252.649 69.14a1.894 1.894 0 1 1-1.895-1.894 1.895 1.895 0 0 1 1.895 1.894",
    transform: "translate(-1213.637 -65.349)",
    style: {
      fill: "#6a4e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 119",
    d: "M1465.252 153.27a1.894 1.894 0 1 1-1.894-1.894 1.894 1.894 0 0 1 1.894 1.894",
    transform: "translate(-1420.245 -147.107)",
    style: {
      fill: "#6a4e3e"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointBrand01);
export default __webpack_public_path__ + "static/media/point_brand01.277f38f6cdcf8be96aef33d3e308d30f.svg";
export { ForwardRef as ReactComponent };